import React from 'react'
import { useTranslation } from 'react-i18next'
import { HelpSection as _HelpSection } from '@jagad/ui'

type HelpSectionProps = {
    onContactClick?: () => void
    helpText?: string
    contactText?: string
}

const HelpSection: React.FC<HelpSectionProps> = ({
    onContactClick,
    helpText,
    contactText,
}) => {
    const { t } = useTranslation()
    return (
        <_HelpSection
            helpText={helpText ?? t('components.helpSection.helpText')}
            contactText={contactText ?? t('components.helpSection.contactText')}
            onContactClick={onContactClick}
        />
    )
}

export default HelpSection
